import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'wait',
  name: 'Wait',
  category: 'flow-control',
  description: 'Pause execution for a duration',
  icon: 'Clock',
  color: 'amber',
  version: '1.0.0',
  subtitle: '={{$parameter.amount}} {{$parameter.unit}}',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
};

export default definition;
